// extracted by mini-css-extract-plugin
export var bodySections = "_8q-8";
export var gray = "_8q-7";
export var green = "_8q-4";
export var iconContainer = "_8q-9";
export var iconWidgetContainer = "_8q-1";
export var phoneIcon = "_8q-2";
export var red = "_8q-5";
export var statusDot = "_8q-3";
export var widgetContainer = "_8q-0";
export var yellow = "_8q-6";